var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22.5002,
    height: 15,
    viewBox: "0 0 22.5002 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2509 5C12.6317 5 13.7509 6.11929 13.7509 7.5C13.7509 8.88071 12.6317 10 11.2509 10C9.87024 10 8.75095 8.88071 8.75095 7.5C8.75095 6.11929 9.87024 5 11.2509 5Z",
    fill: "#2D3035",
    stroke: "#2D3035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2354 0.5C13.302 0.500074 15.4117 1.14901 17.334 2.3916H17.335C19.0753 3.51548 20.6346 5.09295 21.8389 6.95508C21.9436 7.11737 21.9995 7.30686 22 7.5C22.0005 7.69307 21.9456 7.88209 21.8418 8.04492C20.6422 9.92241 19.0867 11.5047 17.3486 12.624C15.4358 13.8555 13.3211 14.4999 11.2354 14.5C9.09918 14.5 7.04072 13.875 5.1172 12.6289L4.79884 12.416C3.21536 11.3238 1.78789 9.82628 0.660169 8.06152L0.659193 8.05957L0.58888 7.93066C0.528232 7.79665 0.497342 7.65024 0.500013 7.50195C0.503594 7.30462 0.564981 7.11217 0.677747 6.9502L0.678724 6.95117C2.14791 4.84481 3.82815 3.22404 5.66701 2.12109C7.46912 1.04003 9.34142 0.5 11.2354 0.5ZM13.1641 2.88086C12.2505 2.50247 11.2453 2.40279 10.2754 2.5957C9.30552 2.78863 8.41509 3.2656 7.71583 3.96484C7.01659 4.66409 6.53963 5.55453 6.34669 6.52441C6.15378 7.49426 6.25347 8.4995 6.63185 9.41309C7.01023 10.3266 7.65059 11.1078 8.47267 11.6572C9.29491 12.2066 10.2621 12.5 11.251 12.5H11.252C12.5773 12.4984 13.848 11.9713 14.7852 11.0342C15.7223 10.097 16.2494 8.82629 16.251 7.50098V7.5C16.251 6.51109 15.9576 5.54393 15.4082 4.72168C14.8588 3.89961 14.0776 3.25924 13.1641 2.88086Z",
    fill: "#2D3035",
    stroke: "#2D3035"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a64764df4bd1403e15fbef9b02957b88.svg";
export { ForwardRef as ReactComponent };